<template>
    <div>
        <!-- Success -->
        <div v-if="success" data-test-view="add-users-success">
            <div class="row">
                <div class="col-md-12">
                    <p>
                        {{ $t(`usersTeams.addUsers.textSuccess.1`) }}
                        <span v-show="sendNow === 'yes'">
                            {{ $t(`usersTeams.addUsers.textSuccess.2`) }}</span
                        >.
                        {{ $t(`usersTeams.addUsers.textSuccess.3`) }}
                    </p>
                    <div v-show="existingUsers.length">
                        <p>
                            <l-text :text="$t(`usersTeams.addUsers.textExistingUsers`)" />
                        </p>
                        <ul>
                            <li v-for="user in existingUsers" :key="user">{{ user }}</li>
                        </ul>
                    </div>
                </div>
            </div>

            <div class="footer">
                <button
                    class="btn btn-raised btn-primary"
                    data-test-id="send-invite-close"
                    @click="close()"
                >
                    {{ $t(`usersTeams.modal.btnClose`) }}
                </button>
            </div>
        </div>
        <!--/Success -->

        <!-- Form -->
        <div v-else data-test-view="add-users">
            <div class="row">
                <div class="col-md-6" data-test-id="add-users-email">
                    <label class="color-dark" for="add-users-email-radio">
                        <input
                            id="add-users-email-radio"
                            v-model="mode"
                            type="radio"
                            value="list"
                        />
                        {{ $t(`usersTeams.addUsers.labelEmailList`) }}
                    </label>
                </div>
                <div class="col-md-6" data-test-id="add-users-import">
                    <label class="color-dark" for="add-users-import-radio">
                        <input
                            id="add-users-import-radio"
                            v-model="mode"
                            type="radio"
                            value="import"
                        />
                        {{ $t(`usersTeams.addUsers.labelImportList`) }}
                    </label>
                </div>
            </div>

            <hr />

            <!-- Email List -->
            <div v-show="mode === 'list'">
                <l-space :size="2" />

                <l-input-text
                    v-model="invite.mails"
                    :label="$t(`usersTeams.addUsers.labelEmail`)"
                    :placeholder="$t(`usersTeams.addUsers.placeholderEmail`)"
                    :optional="false"
                    type="textarea"
                    data-test-id="add-users-email-input"
                />
            </div>
            <!--/Email List -->

            <!-- Import File -->
            <div v-show="mode === 'import'">
                <div>
                    <button
                        class="btn btn-default btn-block btn-raised tw-p-2"
                        @click="exportUsers"
                    >
                        {{ $t(`usersTeams.addUsers.downloadTemplate`) }}
                    </button>
                </div>

                <hr />

                <div>
                    <form name="upload_form">
                        <label
                            class="btn btn-primary btn-block btn-raised tw-p-3 tw-text-center"
                            data-test-id="add-users-import-button"
                            for="import-users-file-input"
                        >
                            {{ $t(`usersTeams.addUsers.uploadFile`) }}
                            <input
                                id="import-users-file-input"
                                type="file"
                                name="file"
                                accept=".csv,.xls,.xlsx"
                                style="display: none;"
                                @change="e => uploadUsers(e)"
                            />
                        </label>
                    </form>
                </div>

                <hr />

                <div v-show="formattedUsers.length" id="import-users-preview">
                    <h4 class="right-line">
                        {{ $t(`usersTeams.addUsers.labelImportPreview`) }}
                    </h4>
                    <div v-for="user in formattedUsers.slice(0, limitUsers)" :key="user.username">
                        <div v-for="column in columns" :key="column._id">
                            <div v-if="user[column._id]" class="tw-grid tw-gap-4 tw-grid-cols-12">
                                <div class="tw-col-span-6 tw-font-semibold tw-line-clamp-1">
                                    {{ column.name }}
                                </div>
                                <div class="tw-col-span-6 tw-line-clamp-1">
                                    {{ user[column._id] }}
                                </div>
                            </div>
                        </div>
                        <hr />
                    </div>
                    <div v-show="limitUsers < formattedUsers.length" class="text-center">
                        <button
                            class="btn btn-primary btn-raised"
                            @click="limitUsers = limitUsers + 50"
                        >
                            {{ $t(`usersTeams.addUsers.labelImportPreviewShowMore`) }}
                        </button>
                    </div>
                    <hr />
                </div>
            </div>
            <!--/Import File-->

            <!-- Send Invites -->

            <div class="row">
                <div class="col-md-6" data-test-id="add-users-send-invites-now">
                    <label
                        v-b-popover.hover.top="$t(`usersTeams.addUsers.labelOneTimePasswords`)"
                        class="color-dark"
                        for="users-send-invites-now-radio"
                    >
                        <input
                            id="users-send-invites-now-radio"
                            v-model="sendNow"
                            type="radio"
                            value="yes"
                        />
                        {{ $t(`usersTeams.addUsers.labelSendInvitesNow`) }}
                    </label>
                </div>
                <div class="col-md-6" data-test-id="add-users-send-invites-later">
                    <label class="color-dark" for="users-send-invites-later-radio">
                        <input
                            id="users-send-invites-later-radio"
                            v-model="sendNow"
                            type="radio"
                            value="no"
                        />
                        {{ $t(`usersTeams.addUsers.labelSendInvitesLater`) }}
                    </label>
                </div>
            </div>

            <l-space :size="2" />

            <div v-show="sendNow === 'yes'">
                <l-input-text
                    v-model="invite.text"
                    :label="$t(`usersTeams.addUsers.labelInviteText`)"
                    :optional="true"
                    type="textarea"
                    data-test-id="invite-text"
                />
            </div>
            <div v-show="sendNow !== 'yes'">
                <p class="explanation">
                    {{ $t(`usersTeams.addUsers.explanationSendInvitesLater`) }}
                </p>
            </div>
            <!--/Send Invites -->

            <hr />

            <div class="footer">
                <button class="btn btn-primary" data-test-id="send-invite-cancel" @click="close()">
                    {{ $t(`usersTeams.addUsers.btnCancel`) }}
                </button>
                <button
                    class="btn btn-raised btn-primary"
                    data-test-id="add-users-create"
                    :disabled="isLoading"
                    @click="createUsers()"
                >
                    {{ $t(`usersTeams.addUsers.btnCreate`) }}
                </button>
            </div>
        </div>
        <!--/Form -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";

import LInputText from "@/components/LInputText";
import LSpace from "@/components/LSpace";
import LText from "@/components/LText";

export default {
    components: {
        LInputText,
        LSpace,
        LText,
    },
    props: {
        close: {
            type: Function,
            required: true, // form router-view
        },
    },
    data() {
        return {
            mode: "list",
            sendNow: "yes",

            invite: {
                mails: "",
                text: this.$t(`usersTeams.sendInvite.defaultInviteText`),
            },

            uploadAttempt: false,
            formattedUsers: [],
            columns: [],
            limitUsers: 20,

            isLoading: false,
            success: false,
        };
    },
    computed: {
        ...mapGetters({
            existingUsers: "users/invite/existingUsers",
            currentUser: "users/current/user",
            currentUserTeamRole: "users/current/teamRole",
        }),
    },
    methods: {
        exportUsers() {
            this.$store.dispatch({
                type: "users/list/export",
                payload: { team: this.currentUserTeamRole.team },
            });
        },
        uploadUsers(e) {
            const { files } = e.target;

            if (!files) {
                return;
            }

            const file = files[0];

            this.$store
                .dispatch({ type: "users/invite/upload", payload: { file } })
                .then(res => {
                    this.formattedUsers = res?.data?.formattedUsers ?? [];
                    this.columns = res?.data?.columns ?? [];
                })
                .finally(() => {
                    this.uploadAttempt = true;

                    document.getElementById("import-users-preview")?.scrollIntoView({
                        behavior: "smooth",
                    });
                });
        },
        createUsers() {
            this.isLoading = true;
            const users = this.formattedUsers.length
                ? this.formattedUsers
                : this.invite.mails
                      .split(",")
                      .map(email => ({ username: email, firstname: "", lastname: "" }));
            const role = "member";
            const text = this.invite.text;
            const teamId = this.currentUserTeamRole.team;
            const sendNow = this.sendNow === "yes";

            this.$store
                .dispatch({
                    type: "users/invite/sendMany",
                    payload: { users, role, text, teamId, sendNow },
                })
                .then(() => {
                    this.isLoading = false;
                    this.success = true;
                });
        },
    },
};
</script>

<style scoped></style>
